var $27f5cd2291ca8a02$exports = {};
$27f5cd2291ca8a02$exports = {
  "rangeOverflow": function rangeOverflow(args) {
    return "O valor deve ser ".concat(args.maxValue, " ou anterior.");
  },
  "rangeReversed": "A data inicial deve ser anterior \xE0 data final.",
  "rangeUnderflow": function rangeUnderflow(args) {
    return "O valor deve ser ".concat(args.minValue, " ou posterior.");
  },
  "unavailableDate": "Data selecionada indispon\xEDvel."
};
export { $27f5cd2291ca8a02$exports as default };